import React, { ReactNode, useState } from "react";
import Popup, { PopupTabs } from "../api/Popup";

import './order-popup.css';

export default function OrderPopup({ children, close, onClose }: OrderPopupProps) {

    return <Popup onClose={onClose}>
        <div className='order-popup'>
            <div className='orders'>{children}</div>
            <div className='order-complete' onClick={onClose}>
                {close}
            </div>
        </div>

    </Popup>
}

type OrderPopupProps = {
    children: ReactNode
    close: ReactNode
    onClose: () => void
}

export function OneButtonPopup({ children, close, onClose, isDisabled }: OneButtonPopupProps) {

    return <Popup onClose={onClose}>
        <div className='order-popup'>
            <div className='orders'>{children}</div>
            <div className='order-complete' onClick={onClose} style={{ opacity: isDisabled ? '0.5' : '1' }}>
                {close}
            </div>
        </div>

    </Popup>
}

type OneButtonPopupProps = {
    children: ReactNode
    close: ReactNode
    onClose: () => void
    isDisabled: boolean
}

export function TwoButtonPopup({ children, rightButtonText, leftButtonText, onRightButtonClick, onLeftButtonClick, isDisabled }: TwoButtonPopupProps) {

    return <Popup onClose={onLeftButtonClick}>
        <div className='dlg-popup' style={{ maxWidth: '590px', width: 'auto' }}>
            <div className='orders'>{children}</div>
            <div className='two-buttons-flex'>
                <button className={'dlg-no-btn'} onClick={onLeftButtonClick}>{leftButtonText}</button>
                <button className={'ok-btn dlg-yes-btn'} onClick={onRightButtonClick} style={{ opacity: isDisabled ? '0.5' : '1' }}>{rightButtonText}</button>
            </div>
        </div>

    </Popup>
}

type TwoButtonPopupProps = {
    children: ReactNode
    isDisabled: boolean
    rightButtonText: ReactNode;
    leftButtonText: ReactNode;
    onRightButtonClick: () => void;
    onLeftButtonClick: () => void;
}

export function TabsPopup({ tabSections, children, close, onClose }: TabsPopupProps) {

    const [selected, setSelected] = useState('0');

    const onPress = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        e.preventDefault();
        const target = window.document.getElementById(
            e.currentTarget.href.split("#")[1]
        );
        setSelected(e.currentTarget.href.substring(e.currentTarget.href.length - 1));
        if (target) {
            target.scrollIntoView({ behavior: "smooth" });
        }
    };

    return <PopupTabs onClose={onClose}>
        <div className='tabs-popup'> 
            <div >
                <div className="scrollmenu">
                    {tabSections?.map((sectionTitle, index) =>
                        <a key={sectionTitle} onClick={(e) => onPress(e)} href={`#${index.toString()}`} style={{ textDecoration: 'none' }}>
                            <div data-to-scrollspy-id={index.toString()} className={selected === index.toString() ? "tabs-scroll-spy selected" : "tabs-scroll-spy"}>
                                {sectionTitle}
                            </div>
                        </a>
                    )}
                </div>
            </div>
            <div className='tabs-orders'>
                <div className="list-position">
                    {children}
                </div>
            </div>
            {/* <div className='orders'>{children}</div> */}
            <div className='popup-button' onClick={onClose}>
                {close}
            </div>
        </div>

    </PopupTabs>
}

type TabsPopupProps = {
    tabSections: string[]
    children: ReactNode
    close: ReactNode
    onClose: () => void
}